import React, {useEffect, useState} from "react";
import InstitutionRepository from "../../repository/InstitutionRepository";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {strings} from "../../Localization/Localization";
import Select from "react-select";
import AreaOfInterestRepository from "../../repository/AreaOfInterestRepository";
import UserAreaOfInterestRepository from "../../repository/UserAreaOfInterestRepository";

const UserEdit = (props) => {

    const [validation] = useState([]);

    const [listInstitutions, setListInstitutions] = useState([]);
    const [selectedInstitutionValue, setSelectedInstitutionValue] = useState([]);

    const [listAreasOfInterest, setListAreasOfInterest] = useState([])

    const [selectedAreaValue, setSelectedAreaValue] = useState([]);
    const [chosenAreas, setChosenAreas] = useState([]);

    const getAreas = () => {
        AreaOfInterestRepository.findAllActive().then(res => {
            res.data.map(item => {
                listAreasOfInterest.push({value: item.id, label: item.nameMk, name: "areasOfInterest_ids"})
            })
        })
    }

    strings.setLanguage(localStorage.getItem("activeLanguage"));

    const getInstitutions = async () => {
        InstitutionRepository.allActiveInstitutions().then(res => {
            res.data.map(item => {
                listInstitutions.push({value: item.id, label: item.nameMk, name: "institutionId"})
            })
        }).catch(err => toast.error(strings.failedToLoadData));
    }

    const handleAreasChange = (areasOfInterest) => {
        if(areasOfInterest != null){
            props.onChange("areasOfInterest_ids", Array.isArray(areasOfInterest) ? areasOfInterest.map(x => x.value) : [])
        }
        else{
            props.onChange("areasOfInterest_ids", null);
        }
        setSelectedAreaValue(Array.isArray(areasOfInterest) ? areasOfInterest.map(x => x.value) : []);
    }

    let getIncludedAreas =  async () => {
        await UserAreaOfInterestRepository.findAllByUserId(props.entity.userId).then(res => {
            let areasForUser = res.data.map(x => x.areaOfInterest)
            setChosenAreas(areasForUser)
            props.onChange("areasOfInterest_ids", areasForUser.map(x => x.id));
        })
    }

    const setValidationErrors = () => {
        validation["email"]=({error: false, name: 'email', message: 'Ве молиме пополнете е-пошта'})
        validation["firstName"]=({error: false, name: 'firstName', message: 'Ве молиме пополнете име'})
        validation["lastName"]=({error: false, name: 'lastName', message: 'Ве молиме пополнете презиме'})
        validation["phone"]=({error: false, name: 'phone', message: 'Ве молиме пополнете телефон'})
        validation["locales"]=({error: false, name: 'locales', message: 'Ве молиме пополнете локал'})
        validation["institution_id"]=({error: false, name: 'institution_id', message: 'Ве молиме пополнете институција'})
        validation["role"]=({error: false, name: 'role', message: 'Ве молиме пополнете тип на корисник'})
    }

    useEffect(() => {
        getInstitutions();
        getAreas();
        getIncludedAreas();
        setValidationErrors();
        if(props.entity.institution !== undefined && props.entity.institution !== null)
            props.onChange("institution_id", props.entity.institution.id)
        chosenAreas.map(item => {
            handleAreasChange(item);
        })
    }, []);

    const onChangeHandler = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        if(validation[name] !== undefined){
            validation[name].error = value === null || value === '';
        }

        props.onChange(name, value);
    };
    const onRoleChangeHandler = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        if(validation[name] !== undefined){
            validation[name].error = value === null || value === '';
        }

        props.onChange(name, value);
    };

    const onSelectedInstitutionChangeHandler = (institution) => {
        if (institution !== null && institution.type !== "blur") {
            props.onChange(institution.name, institution.value)
            validation["institution_id"].error = false
            setSelectedInstitutionValue(institution)
        } else {
            if(institution === null || selectedInstitutionValue === null){
                props.onChange("institution_id", null)
                validation["institution_id"].error = true
                setSelectedInstitutionValue(null)
            }
        }
    }

    const onFileChangeHandler = (event) => {
        props.onChange(event.target.name, event.target.files[0])
    }

    let rolefront;
    let role = localStorage.getItem('role');
    role === "ROLE_ADMIN" ? rolefront = <div className="col">
        <label className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.role}</label>

        <select
            name={"userRole"}
            required
            className="form-control custom-select"
            onChange={(e) => onRoleChangeHandler(e)}
            value={props.entity.userRole}
        >
            <option value="">{strings.rolePlaceholder}</option>
            <option value="ROLE_ADMIN">{strings.admin}</option>
            <option value="ROLE_INSTITUTIONAL_MODERATOR">{strings.moderator}</option>
            <option value="ROLE_EVALUATOR">{strings.responsiblePerson}</option>
            <option value="ROLE_ADMINISTRATIVE_OBSERVER">{strings.manager}</option>
            <option value="ROLE_SUPERVISOR">{strings.supervisor}</option>
        </select>
        <small style={{color: "red"}}>{validation["role"] && validation["role"].error && validation["role"].message}</small>
    </div> : rolefront = <div></div>;

    return (
        <div>
            <div className="col">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.firstName}</label>

                <input
                    required
                    defaultValue={props.entity?.name}
                    name={"name"}
                    type={"text"}
                    onChange={(e) => onChangeHandler(e)}
                    className="form-control"
                />
                <small style={{color: "red"}}>{validation["firstName"] && validation["firstName"].error && validation["firstName"].message}</small>
            </div>
            <div className="col">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.lastName}</label>

                <input
                    name={"lastName"}
                    defaultValue={props.entity?.lastName}
                    type={"text"}
                    onChange={(e) => onChangeHandler(e)}
                    className="form-control"
                    required
                />
                <small style={{color: "red"}}>{validation["lastName"] && validation["lastName"].error && validation["lastName"].message}</small>
            </div>
            <div
                className="col-12">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10"><small
                    style={{color: "red"}}></small>{strings.embg}</label>

                <input
                    name={"embg"}
                    type={"text"}
                    maxlength="13"
                    defaultValue={props.entity?.embg}
                    className="form-control"
                    onChange={(e) => onChangeHandler(e)}
                    onBlur={(e) => onChangeHandler(e)}
                />
            </div>
            <div className="col-12">
                <div className="row">
                    <div className="col-9">
                        <label
                            className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.phone}</label>

                        <input
                            name={"phone1"}
                            defaultValue={props.entity?.phone1}
                            type={"text"}
                            onChange={(e) => onChangeHandler(e)}
                            className="form-control"
                            required
                        />
                        <small style={{color: "red"}}>{validation["phone"] && validation["phone"].error && validation["phone"].message}</small>
                    </div>
                    <div className="col-3">
                        <label
                            className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.localFirst}</label>

                        <input
                            name={"locales1"}
                            defaultValue={props.entity?.locales1}
                            type={"text"}
                            onChange={(e) => onChangeHandler(e)}
                            className="form-control"
                            required
                        />
                        <small style={{color: "red"}}>{validation["locales"] && validation["locales"].error && validation["locales"].message}</small>
                    </div>
                </div>
            </div>
            <br/>

            <div className="col-12">
                <div className="row">
                    <div className="col-9">
                        <label
                            className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.alternativePhone}</label>

                        <input
                            name={"phone2"}
                            defaultValue={props.entity?.phone2}
                            type={"text"}
                            onChange={(e) => onChangeHandler(e)}
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="col-3">
                        <label
                            className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.localFirst}</label>

                        <input
                            name={"locales2"}
                            defaultValue={props.entity?.locales2}
                            type={"text"}
                            onChange={(e) => onChangeHandler(e)}
                            className="form-control"
                            required
                        />
                    </div>
                </div>
            </div>
            <br/>

            <div className="col-12">
                <div className="row">
                    <div className="col-9">
                        <label
                            className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.alternativeSecondPhone}</label>

                        <input
                            name={"phone3"}
                            defaultValue={props.entity?.phone3}
                            type={"text"}
                            onChange={(e) => onChangeHandler(e)}
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="col-3">
                        <label
                            className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.localFirst}</label>

                        <input
                            name={"locales3"}
                            defaultValue={props.entity?.locales3}
                            type={"text"}
                            onChange={(e) => onChangeHandler(e)}
                            className="form-control"
                            required
                        />
                    </div>
                </div>
            </div>
            <br/>

            <div className="col">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.email}</label>

                <input
                    name={"email1"}
                    defaultValue={props.entity?.email1}
                    type={"email"}
                    onChange={(e) => onChangeHandler(e)}
                    className="form-control"
                    required
                />
                <small style={{color: "red"}}>{validation["email"] && validation["email"].error && validation["email"].message}</small>
            </div>
            <div className="col">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.alternativeEmail}</label>

                <input
                    name={"email2"}
                    defaultValue={props.entity?.email2}
                    type={"email"}
                    onChange={(e) => onChangeHandler(e)}
                    className="form-control"
                    required
                />
            </div>
            <div className="col">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.alternativeEmail}</label>

                <input
                    name={"email3"}
                    defaultValue={props.entity?.email3}
                    type={"email"}
                    onChange={(e) => onChangeHandler(e)}
                    className="form-control"
                    required
                />
            </div>
            {rolefront}
            {role === "ROLE_ADMIN" ? <>
                <div className="col">
                    <label
                        className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.institution}</label>
                    <Select
                        placeholder={strings.searchForInstitution}
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isSearchable={true}
                        options={listInstitutions}
                        onChange={onSelectedInstitutionChangeHandler}
                        name={"institutionId"}
                        defaultValue={props.entity.institutionId !== null && props.entity.institutionId!== undefined ? {
                            value: props.entity.institutionId,
                            label: props.entity.institution,
                            name: "institutionId"
                        } : ""}

                    />
                    <small style={{color: "red"}}>{validation["institution_id"] && validation["institution_id"].error && validation["institution_id"].message}</small>
                </div>
                <div className="col">
                <label
                        className="weight400 text-upper control-label control-label-xl margin-top-10">{strings.nomination}</label>
                    <input
                        id="attachment"
                        name={"attachment"}
                        type={"file"}
                        className="form-control"
                        onChange={(e) => onFileChangeHandler(e)}
                    />
                    <small style={{color: "red"}}>{validation["attachment"] && validation["attachment"].error && validation["attachment"].message}</small>
                </div>
                </>: <div></div>
            }

            <div className="col mt-4 mb-4">
                <label
                    className="weight400 text-upper control-label control-label-xl margin-top-10">
                    {strings.areasOfInterest}
                </label>

                {chosenAreas.length > 0 ? (
                    <Select
                        placeholder={""}
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isMulti={true}
                        isSearchable={true}
                        options={listAreasOfInterest}
                        defaultValue={chosenAreas?.map(x => ({id: x?.id, label: x?.nameMk, value: x?.id}))}
                        onChange={handleAreasChange}
                        name={"areasOfInterest_ids"}
                    />
                ) : ''}

                {chosenAreas.length === 0 ? (
                    <Select
                        placeholder={""}
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={false}
                        isLoading={false}
                        isClearable={true}
                        isRtl={false}
                        isMulti={true}
                        isSearchable={true}
                        options={listAreasOfInterest}
                        onChange={handleAreasChange}
                        name={"areasOfInterest_ids"}
                    />
                ) : ''}

            </div>
        </div>
    );
};
export default UserEdit;
